/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Resource Selectors 

import {
	RESOURCE_TYPE_USER_ACCOUNT,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE,
	RESOURCE_TYPE_USER_HISTORY_ENTRY,
	RESOURCE_TYPE_BALANCE_CHANGE_LOG,
	RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA,
	RESOURCE_TYPE_USER_ACCOUNT_SETTINGS,
	RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST,
	RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION,
	RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING,
	RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS,
	RESOURCE_TYPE_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_PASSWORD,
	RESOURCE_TYPE_EXPIRED_PASSWORD,
	RESOURCE_TYPE_PASSWORD_RESET,
	RESOURCE_TYPE_DEPOSIT,
	RESOURCE_TYPE_DEPOSIT_INVITE,
	RESOURCE_TYPE_DEPOSIT_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_INTEREST,
	RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY,
	RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_USER_STATS,
	RESOURCE_TYPE_DEPOSIT_BANK_MAPPING,
	RESOURCE_TYPE_DEPOSITS_BULK_IMPORT,
	RESOURCE_TYPE_DEPOSIT_INTEREST_LOG,
	RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS,
	RESOURCE_TYPE_PMC_REPORT_TIMETABLE,
	RESOURCE_TYPE_DEPOSIT_GROUP,
	RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_USER_GROUP,
	RESOURCE_TYPE_PROPERTY_GROUP,
	RESOURCE_TYPE_PROPERTY_USER_GROUP,
	RESOURCE_TYPE_DISPUTE,
	RESOURCE_TYPE_DISPUTE_SPLIT,
	RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST,
	RESOURCE_TYPE_PROPERTY,
	RESOURCE_TYPE_PROPERTY_ADDRESS,
	RESOURCE_TYPE_COMPLIANCE,
	RESOURCE_TYPE_COMPLIANCE_RULE,
	RESOURCE_TYPE_COMPLIANCE_HISTORY,
	RESOURCE_TYPE_EMAIL_TEMPLATE,
	RESOURCE_TYPE_EMAIL_VERIFICATION,
	RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD,
	RESOURCE_TYPE_EMAIL_EVENT,
	RESOURCE_TYPE_SENT_EMAIL,
	RESOURCE_TYPE_MAILBOX,
	RESOURCE_TYPE_MAILBOX_META_DATA,
	RESOURCE_TYPE_MAILBOX_MESSAGE,
	RESOURCE_TYPE_PERMISSION_ENTRY,
	RESOURCE_TYPE_PERMISSION_LOG_ENTRY,
	RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS,
	RESOURCE_TYPE_RESOURCE_PERMISSIONS,
	RESOURCE_TYPE_ORGANIZATION,
	RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE,
	RESOURCE_TYPE_INVOICE,
	RESOURCE_TYPE_INVOICE_ITEM,
	RESOURCE_TYPE_PAYMENT_REQUEST,
	RESOURCE_TYPE_STRIPE_PAYMENT_LOG,
	RESOURCE_TYPE_USER_WITHDRAW,
	RESOURCE_TYPE_PRIORITY_ACH_PAYMENT,
	RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT,
	RESOURCE_TYPE_LOAN_APPLICATION,
	RESOURCE_TYPE_LOAN_SYSTEM_INFO,
	RESOURCE_TYPE_LOAN,
	RESOURCE_TYPE_LOAN_HISTORY,
	RESOURCE_TYPE_LOAN_PAYMENT_LOG,
	RESOURCE_TYPE_STRIPE_WEBHOOK_LOG,
	RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO,
	RESOURCE_TYPE_SEZZLE_ORDER,
	RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT,
	RESOURCE_TYPE_BANK_ACCOUNT,
	RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE,
	RESOURCE_TYPE_BANK_ACCOUNT_INTEREST,
	RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD,
	RESOURCE_TYPE_BANK_TRANSFER,
	RESOURCE_TYPE_BULK_FUNDS_TRANSFER,
	RESOURCE_TYPE_FUNDS_LOCK,
	RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG,
	RESOURCE_TYPE_RELEASED_FUNDS_LOCK,
	RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER,
	RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG,
	RESOURCE_TYPE_EVENT,
	RESOURCE_TYPE_EVENT_HOOK,
	RESOURCE_TYPE_NOTIFICATION,
	RESOURCE_TYPE_ACTION_ITEM,
	RESOURCE_TYPE_UPDATE_LOG_ENTRY,
	RESOURCE_TYPE_STORAGE_FILE,
	RESOURCE_TYPE_ATTACHED_STORAGE_FILES,
	RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY,
	RESOURCE_TYPE_SNAPSHOT,
	RESOURCE_TYPE_IP_ADDRESS,
	RESOURCE_TYPE_KNOWN_IP_ADDRESS,
	RESOURCE_TYPE_USER_AGENT,
	RESOURCE_TYPE_KNOWN_USER_AGENT,
	RESOURCE_TYPE_SYSTEM_STATS,
	RESOURCE_TYPE_RESOURCE_NOTE,
	RESOURCE_TYPE_DEPOSIFY_TAG,
	RESOURCE_TYPE_PERMANENT_LINK,
	RESOURCE_TYPE_ONLINE_USER,
	RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS,
	RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS,
	RESOURCE_TYPE_YARDI_VOYAGER_PET,
	RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_PHONE,
	RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR,
	RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY,
	RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS
} from "../constants/resourceTypeConstants";
import {createSelector} from 'reselect'

export const resourcesSelector = state => state.resources.resources;
export const uuidSelector = (state, incomingUUID) => incomingUUID;

export const allUserAccountsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT] || {}
);
export const allUserAccountBalancesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT_BALANCE] || {}
);
export const allUserAccountBalanceSourcesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE] || {}
);
export const allUserHistoryEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_HISTORY_ENTRY] || {}
);
export const allBalanceChangeLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BALANCE_CHANGE_LOG] || {}
);
export const allInternationalBankAccountsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT] || {}
);
export const allUSDomesticBankAccountsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT] || {}
);
export const allUserBankAccountDeltasSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA] || {}
);
export const allUserAccountSettingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT_SETTINGS] || {}
);
export const allAdminGhostUserAccountsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST] || {}
);
export const allUserAccountFinalizationsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION] || {}
);
export const allThirdPartyUserAccountMappingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING] || {}
);
export const allPreviousEmailAddressesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS] || {}
);
export const allPendingEmailChangesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PENDING_EMAIL_CHANGE] || {}
);
export const allArchivedPendingEmailChangesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE] || {}
);
export const allPasswordsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PASSWORD] || {}
);
export const allExpiredPasswordsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EXPIRED_PASSWORD] || {}
);
export const allPasswordResetsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PASSWORD_RESET] || {}
);
export const allDepositsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT] || {}
);
export const allDepositInvitesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_INVITE] || {}
);
export const allDepositAdjustmentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_ADJUSTMENT] || {}
);
export const allDepositInterestsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_INTEREST] || {}
);
export const allDepositHistoryEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY] || {}
);
export const allDepositCloseRequestsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST] || {}
);
export const allDepositUserStatsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_USER_STATS] || {}
);
export const allDepositBankMappingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_BANK_MAPPING] || {}
);
export const allDepositBulkImportsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSITS_BULK_IMPORT] || {}
);
export const allDepositInterestLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_INTEREST_LOG] || {}
);
export const allArchivedDepositCloseRequestsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST] || {}
);
export const allDepositWithheldFundsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS] || {}
);
export const allPmcReportTimetablesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PMC_REPORT_TIMETABLE] || {}
);
export const allDepositGroupsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_GROUP] || {}
);
export const allDepositPostCloseAdjustmentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT] || {}
);
export const allDepositUserGroupsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIT_USER_GROUP] || {}
);
export const allPropertyGroupsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PROPERTY_GROUP] || {}
);
export const allPropertyUserGroupsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PROPERTY_USER_GROUP] || {}
);
export const allDisputesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DISPUTE] || {}
);
export const allDisputeSplitsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DISPUTE_SPLIT] || {}
);
export const allDisputeInterventionRequestsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST] || {}
);
export const allPropertiesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PROPERTY] || {}
);
export const allPropertyAddressesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PROPERTY_ADDRESS] || {}
);
export const allCompliancesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_COMPLIANCE] || {}
);
export const allComplianceRuleSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_COMPLIANCE_RULE] || {}
);
export const allComplianceHistoriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_COMPLIANCE_HISTORY] || {}
);
export const allEmailTemplatesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EMAIL_TEMPLATE] || {}
);
export const allEmailVerificationsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EMAIL_VERIFICATION] || {}
);
export const allEmailVerificationRecordsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD] || {}
);
export const allEmailEventsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EMAIL_EVENT] || {}
);
export const allSentEmailsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_SENT_EMAIL] || {}
);
export const allMailboxesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_MAILBOX] || {}
);
export const allMailboxMetaDataSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_MAILBOX_META_DATA] || {}
);
export const allMailboxMessagesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_MAILBOX_MESSAGE] || {}
);
export const allPermissionEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PERMISSION_ENTRY] || {}
);
export const allPermissionLogEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PERMISSION_LOG_ENTRY] || {}
);
export const allPermissionsOrganizationSettingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS] || {}
);
export const allResourcePermissionsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_RESOURCE_PERMISSIONS] || {}
);
export const allOrganizationsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ORGANIZATION] || {}
);
export const allOrganizationResourcePermissionRulesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE] || {}
);
export const allInvoicesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_INVOICE] || {}
);
export const allInvoiceItemsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_INVOICE_ITEM] || {}
);
export const allPaymentRequestsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PAYMENT_REQUEST] || {}
);
export const allStripePaymentLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_STRIPE_PAYMENT_LOG] || {}
);
export const allUserWithdrawsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_WITHDRAW] || {}
);
export const allPriorityAchPaymentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PRIORITY_ACH_PAYMENT] || {}
);
export const allPriorityAchRecurringPaymentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT] || {}
);
export const allLoanApplicationsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_LOAN_APPLICATION] || {}
);
export const allLoanSystemInfosSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_LOAN_SYSTEM_INFO] || {}
);
export const allLoansSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_LOAN] || {}
);
export const allHistoryEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_LOAN_HISTORY] || {}
);
export const allLoanPaymentLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_LOAN_PAYMENT_LOG] || {}
);
export const allLogEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_STRIPE_WEBHOOK_LOG] || {}
);
export const allInfoSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO] || {}
);
export const allSezzleOrdersSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_SEZZLE_ORDER] || {}
);
export const allSezzleWebhookEventsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT] || {}
);
export const allBankAccountsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BANK_ACCOUNT] || {}
);
export const allBankAccountHistoricalInterestRatesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE] || {}
);
export const allBankAccountInterestsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BANK_ACCOUNT_INTEREST] || {}
);
export const allBankAccountBalanceRecordsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD] || {}
);
export const allBankTransfersSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BANK_TRANSFER] || {}
);
export const allBulkFundsTransfersSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BULK_FUNDS_TRANSFER] || {}
);
export const allFundsLocksSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_FUNDS_LOCK] || {}
);
export const allFundsLockReleaseLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG] || {}
);
export const allReleasedFundsLocksSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_RELEASED_FUNDS_LOCK] || {}
);
export const allBalanceSourceTransfersSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER] || {}
);
export const allCreditUserAccountLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG] || {}
);
export const allEventsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EVENT] || {}
);
export const allEventHooksSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_EVENT_HOOK] || {}
);
export const allNotificationsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_NOTIFICATION] || {}
);
export const allActionItemsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ACTION_ITEM] || {}
);
export const allUpdateLogsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_UPDATE_LOG_ENTRY] || {}
);
export const allStorageFilesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_STORAGE_FILE] || {}
);
export const allAttachedStorageFilesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ATTACHED_STORAGE_FILES] || {}
);
export const allSystemHistoryEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY] || {}
);
export const allSnapshotsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_SNAPSHOT] || {}
);
export const allIpAddressesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_IP_ADDRESS] || {}
);
export const allKnownIpAddressesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_KNOWN_IP_ADDRESS] || {}
);
export const allUserAgentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_USER_AGENT] || {}
);
export const allKnownUserAgentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_KNOWN_USER_AGENT] || {}
);
export const allSystemStatsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_SYSTEM_STATS] || {}
);
export const allResourceNoteSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_RESOURCE_NOTE] || {}
);
export const allDeposifyTagsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_DEPOSIFY_TAG] || {}
);
export const allLinksSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_PERMANENT_LINK] || {}
);
export const allOnlineUsersSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_ONLINE_USER] || {}
);
export const allFrontendGeneralSettingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS] || {}
);
export const allYardiScreeningWorksProXmlSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML] || {}
);
export const allYardiVoyagerXmlSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_XML] || {}
);
export const allYardiVoyagerTransactionsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION] || {}
);
export const allYardiVoyagerResidentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT] || {}
);
export const allYardiVoyagerResidentCustomColumnsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN] || {}
);
export const allYardiVoyagerPropertyUnitsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT] || {}
);
export const allYardiVoyagerPropertiesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY] || {}
);
export const allYardiVoyagerPmcServiceInterfaceVersionsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION] || {}
);
export const allYardiVoyagerPmcsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PMC] || {}
);
export const allYardiVoyagerPmcCredentialsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS] || {}
);
export const allYardiVoyagerPetsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PET] || {}
);
export const allYardiVoyagerIlsGuestCardEventsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT] || {}
);
export const allYardiVoyagerChargesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE] || {}
);
export const allYardiVoyagerChargeCodesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE] || {}
);
export const allYardiVoyagerDepositCreateIntentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT] || {}
);
export const allYardiVoyagerDepositCloseIntentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT] || {}
);
export const allYardiVoyagerDepositWithholdIntentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT] || {}
);
export const allYardiVoyagerEventsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_EVENT] || {}
);
export const allYardiVoyagerFlexDepositIntentsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT] || {}
);
export const allYardiVoyagerPhonesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PHONE] || {}
);
export const allYardiVoyagerOtherOccupantsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT] || {}
);
export const allYardiVoyagerPmcCustomColumnSettingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS] || {}
);
export const allYardiVoyagerPmcStatsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS] || {}
);
export const allYardiVoyagerPmcStatsCollectorsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR] || {}
);
export const allYardiVoyagerActiveScanLogEntriesSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY] || {}
);
export const allYardiVoyagerSystemSettingsSelector = createSelector(
	[resourcesSelector],
	(resources) => resources[RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS] || {}
);

export const makeUserAccountSelector = () => createSelector(
	[allUserAccountsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeUserAccountBalanceSelector = () => createSelector(
	[allUserAccountBalancesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeUserAccountBalanceSourceSelector = () => createSelector(
	[allUserAccountBalanceSourcesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeUserHistoryEntrySelector = () => createSelector(
	[allUserHistoryEntriesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeBalanceChangeLogSelector = () => createSelector(
	[allBalanceChangeLogsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeInternationalUserBankAccountSelector = () => createSelector(
	[allInternationalBankAccountsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeUSDomesticUserBankAccountSelector = () => createSelector(
	[allUSDomesticBankAccountsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeUserBankAccountDeltaSelector = () => createSelector(
	[allUserBankAccountDeltasSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeUserAccountSettingsSelector = () => createSelector(
	[allUserAccountSettingsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeAdminGhostUserAccountSelector = () => createSelector(
	[allAdminGhostUserAccountsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeUserAccountFinalizationSelector = () => createSelector(
	[allUserAccountFinalizationsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeThirdPartyUserAccountMappingSelector = () => createSelector(
	[allThirdPartyUserAccountMappingsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePreviousEmailAddressSelector = () => createSelector(
	[allPreviousEmailAddressesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePendingEmailChangeSelector = () => createSelector(
	[allPendingEmailChangesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeArchivedPendingEmailChangeSelector = () => createSelector(
	[allArchivedPendingEmailChangesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePasswordSelector = () => createSelector(
	[allPasswordsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeExpiredPasswordSelector = () => createSelector(
	[allExpiredPasswordsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePasswordResetSelector = () => createSelector(
	[allPasswordResetsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositSelector = () => createSelector(
	[allDepositsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositInviteSelector = () => createSelector(
	[allDepositInvitesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositAdjustmentSelector = () => createSelector(
	[allDepositAdjustmentsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositInterestSelector = () => createSelector(
	[allDepositInterestsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositHistoryEntrySelector = () => createSelector(
	[allDepositHistoryEntriesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositCloseRequestSelector = () => createSelector(
	[allDepositCloseRequestsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositUserStatsSelector = () => createSelector(
	[allDepositUserStatsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositBankMappingSelector = () => createSelector(
	[allDepositBankMappingsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositBulkImportSelector = () => createSelector(
	[allDepositBulkImportsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositInterestLogSelector = () => createSelector(
	[allDepositInterestLogsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeArchivedDepositCloseRequestSelector = () => createSelector(
	[allArchivedDepositCloseRequestsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositWithheldFundsSelector = () => createSelector(
	[allDepositWithheldFundsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePMCReportTimetableSelector = () => createSelector(
	[allPmcReportTimetablesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositGroupSelector = () => createSelector(
	[allDepositGroupsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositPostCloseAdjustmentSelector = () => createSelector(
	[allDepositPostCloseAdjustmentsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDepositUserGroupSelector = () => createSelector(
	[allDepositUserGroupsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePropertyGroupSelector = () => createSelector(
	[allPropertyGroupsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePropertyUserGroupSelector = () => createSelector(
	[allPropertyUserGroupsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDisputeSelector = () => createSelector(
	[allDisputesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDisputeSplitSelector = () => createSelector(
	[allDisputeSplitsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDisputeInterventionRequestSelector = () => createSelector(
	[allDisputeInterventionRequestsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePropertySelector = () => createSelector(
	[allPropertiesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePropertyAddressSelector = () => createSelector(
	[allPropertyAddressesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeComplianceSelector = () => createSelector(
	[allCompliancesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeComplianceRuleSelector = () => createSelector(
	[allComplianceRuleSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeComplianceHistorySelector = () => createSelector(
	[allComplianceHistoriesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeEmailTemplateSelector = () => createSelector(
	[allEmailTemplatesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeEmailVerificationSelector = () => createSelector(
	[allEmailVerificationsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeEmailVerificationRecordSelector = () => createSelector(
	[allEmailVerificationRecordsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeEmailEventSelector = () => createSelector(
	[allEmailEventsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeSentEmailSelector = () => createSelector(
	[allSentEmailsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeMailboxSelector = () => createSelector(
	[allMailboxesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeMailboxMetaDataSelector = () => createSelector(
	[allMailboxMetaDataSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeMailboxMessageSelector = () => createSelector(
	[allMailboxMessagesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePermissionEntrySelector = () => createSelector(
	[allPermissionEntriesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePermissionLogEntrySelector = () => createSelector(
	[allPermissionLogEntriesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePermissionsOrganizationSettingsSelector = () => createSelector(
	[allPermissionsOrganizationSettingsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeResourcePermissionSelector = () => createSelector(
	[allResourcePermissionsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeOrganizationSelector = () => createSelector(
	[allOrganizationsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeOrganizationResourcePermissionRuleSelector = () => createSelector(
	[allOrganizationResourcePermissionRulesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeInvoiceSelector = () => createSelector(
	[allInvoicesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeInvoiceItemSelector = () => createSelector(
	[allInvoiceItemsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePaymentRequestSelector = () => createSelector(
	[allPaymentRequestsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeStripePaymentLogSelector = () => createSelector(
	[allStripePaymentLogsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeUserWithdrawSelector = () => createSelector(
	[allUserWithdrawsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePriorityACHPaymentSelector = () => createSelector(
	[allPriorityAchPaymentsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePriorityACHRecurringPaymentSelector = () => createSelector(
	[allPriorityAchRecurringPaymentsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeLoanApplicationSelector = () => createSelector(
	[allLoanApplicationsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeLoanSystemInfoSelector = () => createSelector(
	[allLoanSystemInfosSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeLoanSelector = () => createSelector(
	[allLoansSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeLoanHistorySelector = () => createSelector(
	[allHistoryEntriesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeLoanPaymentLogSelector = () => createSelector(
	[allLoanPaymentLogsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeStripeWebhookLogSelector = () => createSelector(
	[allLogEntriesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeUserAccountPaymentProviderInfoSelector = () => createSelector(
	[allInfoSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeSezzleOrderSelector = () => createSelector(
	[allSezzleOrdersSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeSezzleWebhookEventSelector = () => createSelector(
	[allSezzleWebhookEventsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeBankAccountSelector = () => createSelector(
	[allBankAccountsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeBankAccountHistoricalInterestRateSelector = () => createSelector(
	[allBankAccountHistoricalInterestRatesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeBankAccountInterestSelector = () => createSelector(
	[allBankAccountInterestsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeBankAccountBalanceRecordSelector = () => createSelector(
	[allBankAccountBalanceRecordsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeBankTransferSelector = () => createSelector(
	[allBankTransfersSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeBulkFundsTransferSelector = () => createSelector(
	[allBulkFundsTransfersSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeFundsLockSelector = () => createSelector(
	[allFundsLocksSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeFundsLockReleaseLogSelector = () => createSelector(
	[allFundsLockReleaseLogsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeReleasedFundsLockSelector = () => createSelector(
	[allReleasedFundsLocksSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeBalanceSourceTransferSelector = () => createSelector(
	[allBalanceSourceTransfersSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeCreditUserAccountLogSelector = () => createSelector(
	[allCreditUserAccountLogsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeEventSelector = () => createSelector(
	[allEventsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeEventHookSelector = () => createSelector(
	[allEventHooksSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeNotificationSelector = () => createSelector(
	[allNotificationsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeActionItemSelector = () => createSelector(
	[allActionItemsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeUpdateLogSelector = () => createSelector(
	[allUpdateLogsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeStorageFileSelector = () => createSelector(
	[allStorageFilesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeAttachedStorageFilesSelector = () => createSelector(
	[allAttachedStorageFilesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeSystemHistoryEntrySelector = () => createSelector(
	[allSystemHistoryEntriesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeSnapshotSelector = () => createSelector(
	[allSnapshotsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeIPAddressSelector = () => createSelector(
	[allIpAddressesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeKnownIPAddressSelector = () => createSelector(
	[allKnownIpAddressesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeUserAgentSelector = () => createSelector(
	[allUserAgentsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeKnownUserAgentSelector = () => createSelector(
	[allKnownUserAgentsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeSystemStatsSelector = () => createSelector(
	[allSystemStatsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeResourceNoteSelector = () => createSelector(
	[allResourceNoteSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeDeposifyTagSelector = () => createSelector(
	[allDeposifyTagsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makePermanentLinkSelector = () => createSelector(
	[allLinksSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeOnlineUserSelector = () => createSelector(
	[allOnlineUsersSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeFrontendGeneralSettingsSelector = () => createSelector(
	[allFrontendGeneralSettingsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiScreeningWorksProXMLSelector = () => createSelector(
	[allYardiScreeningWorksProXmlSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerXMLSelector = () => createSelector(
	[allYardiVoyagerXmlSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerTransactionSelector = () => createSelector(
	[allYardiVoyagerTransactionsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerResidentSelector = () => createSelector(
	[allYardiVoyagerResidentsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerResidentCustomColumnSelector = () => createSelector(
	[allYardiVoyagerResidentCustomColumnsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerPropertyUnitSelector = () => createSelector(
	[allYardiVoyagerPropertyUnitsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerPropertySelector = () => createSelector(
	[allYardiVoyagerPropertiesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerPMCServiceInterfaceVersionSelector = () => createSelector(
	[allYardiVoyagerPmcServiceInterfaceVersionsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerPMCSelector = () => createSelector(
	[allYardiVoyagerPmcsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerPMCCredentialsSelector = () => createSelector(
	[allYardiVoyagerPmcCredentialsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerPetSelector = () => createSelector(
	[allYardiVoyagerPetsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerILSGuestCardEventSelector = () => createSelector(
	[allYardiVoyagerIlsGuestCardEventsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerChargeSelector = () => createSelector(
	[allYardiVoyagerChargesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerChargeCodeSelector = () => createSelector(
	[allYardiVoyagerChargeCodesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerDepositCreateIntentSelector = () => createSelector(
	[allYardiVoyagerDepositCreateIntentsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerDepositCloseIntentSelector = () => createSelector(
	[allYardiVoyagerDepositCloseIntentsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerDepositWithholdIntentSelector = () => createSelector(
	[allYardiVoyagerDepositWithholdIntentsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerEventSelector = () => createSelector(
	[allYardiVoyagerEventsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerFlexDepositIntentSelector = () => createSelector(
	[allYardiVoyagerFlexDepositIntentsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerPhoneSelector = () => createSelector(
	[allYardiVoyagerPhonesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerOtherOccupantSelector = () => createSelector(
	[allYardiVoyagerOtherOccupantsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerPMCCustomColumnSettingsSelector = () => createSelector(
	[allYardiVoyagerPmcCustomColumnSettingsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerPMCStatsSelector = () => createSelector(
	[allYardiVoyagerPmcStatsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerPMCStatsCollectorSelector = () => createSelector(
	[allYardiVoyagerPmcStatsCollectorsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerActiveScanLogEntrySelector = () => createSelector(
	[allYardiVoyagerActiveScanLogEntriesSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
export const makeYardiVoyagerSystemSettingsSelector = () => createSelector(
	[allYardiVoyagerSystemSettingsSelector, uuidSelector],
	(incomingList, resourceUID) => incomingList[resourceUID]
);
